// extracted by mini-css-extract-plugin
export default {"custom-geocoder":"CustomGeocoder_custom-geocoder__LaLS9","custom-geocoder__suggestions":"CustomGeocoder_custom-geocoder__suggestions__r9MvI"};